import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const ContentStyled = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('mobile')]: {
    '& .onboardingSuccessStatus-subtitle': {
      fontSize: 14,
    },
  },
}));
